import React, {createContext, useContext, useState, Dispatch, SetStateAction, FC} from 'react'
import {WithChildren} from '../../../../template/_metronic/helpers'

interface InitialValues {
  email: string
  setEmail: Dispatch<SetStateAction<string>>
}

type AuthContextType = {
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
}

const initialValues: InitialValues = {
  email: '',
  setEmail: () => {},
}

const AuthContext = createContext<AuthContextType>(initialValues)

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [email, setEmail] = useState<string>(initialValues.email)

  return <AuthContext.Provider value={{email, setEmail}}>{children}</AuthContext.Provider>
}

const useAuth = () => useContext(AuthContext)

export {AuthProvider, useAuth}
